import axios from 'axios';
import { API_URL } from './helper';

const $api = axios.create({
    withCredentials: true,
    baseURL: API_URL
})

$api.interceptors.request.use((config) => {
    const user = JSON.parse(localStorage.getItem('user'));
    if (user && user.token) {
        config.headers.Authorization = 'Bearer ' + user.token;
    }
    return config;
})

$api.interceptors.response.use((config) => {
    return config;
}, async (error) => {
    const originalRequest = error.config; //изначальный запрос
    
    if (error.response.status == 401 && error.config && !error.config._isRetry) {
        originalRequest._isRetry = true;
        
        try {
            const response = await axios.get(`${API_URL}/token/refresh`, { withCredentials: true });
            //console.log(response)
            if (response && response.data) {
                localStorage.removeItem('user');
                const userData = response.data;
                const user = {
                    name: userData.user.name,
                    id: userData.user.id,
                    phone: userData.user.phone,
                    email: userData.user.email,
                    isActivated: userData.user.isActivated,
                    role: userData.user.role,
                    promoId: userData.user.promoId
                }
                localStorage.setItem('user', JSON.stringify({ user: user, token: userData.accessToken }));
                return $api.request(originalRequest);
                
            }
        }
        catch (error) {
            console.log('User not authenticated');
            this.$store.dispatch('logout', {});
        } 
    }
    throw error;
})

export default $api